<template>
  <div v-if="isShow" id="createCompany" :style="`zIndex:${zIndex}`">
    <div class="createCompany-title">
      <h2>新建公司</h2>
      <a class="createCompany-close" href="javascript:;" title="关闭" @click="close">X</a>
    </div>
    <div class="createCompany-type pd8">
      <p class="company-type-title">1.公司名称（必填项）</p>
      <div class="flex pdtb8">
        <div :class="[inputError.公司名称 ? 'inputError' : '', 'flex flex-1 pdr8']">
          <span class="label">公司名称：</span>
          <el-select
            v-model="company.公司名称"
            size="mini"
            placeholder="公司名称"
            filterable
            remote
            allow-create
            default-first-option
            :remote-method="newCheckCompanyName"
            @change="checkRequiredField('公司名称')"
          >
            <el-option v-for="item in companyNameOptions" :key="item._id" :label="item.公司名称" :value="item.公司名称">
              <span style="float: left">{{ item.公司名称 }}</span>
              <span v-if="item.from !== 'qixin'" style="float: right">（已存在）</span>
            </el-option>
          </el-select>
        </div>
        <div :class="[inputError.简称 ? 'inputError' : '', 'input', 'flex flex-1 pdr8']">
          <span class="label">简称：</span>
          <el-input
            v-model="company.简称"
            size="mini"
            placeholder="简称"
            @blur="checkRequiredField('简称')"
            @change="checkRequiredField('简称')"
          ></el-input>
        </div>
        <div :class="[inputError.行业 ? 'inputError' : '', 'input', 'flex flex-1 pdr8']">
          <span class="label">行业：</span>
          <el-select
            v-model="company.行业"
            class="edit-input"
            size="mini"
            filterable
            @blur="checkRequiredField('行业')"
            @change="checkRequiredField('行业')"
          >
            <el-option v-for="item in industry" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="hasCreateCompany && hasCreateCompany._id" class="flex pdtb8">
        <span style="font-weight: 800;">该公司已存在：</span>
        <span class="company-pointer" @click="openCompany(hasCreateCompany)">{{ hasCreateCompany.name }}</span>
      </div>
      <div class="content-row hasCreateCompany flex pdtb8">
        <span class="label">别名：</span>
        <AddTagInput @addTag="confirmAlias">
          <el-tag
            v-for="item in companyAliasArr"
            :key="item._id"
            :type="item.type"
            closable
            size="mini"
            style="margin:0 4px 4px 0"
            :disable-transitions="false"
            @close="deleteAlias(item)"
            >{{ item.name }}</el-tag
          >
        </AddTagInput>
      </div>
    </div>
    <div class="createCompany-type pd8">
      <p class="company-type-title">2.公司详情</p>
      <!-- 智能填写 -->
      <div class="content-row">
        <p class="propject_detail_info_title">
          <span class="mr10">智能填写</span>
          <span class="mr10">
            <div
              class="radish-btn radish-btn-primary radish-btn-small"
              @click="download({ url: `${host}/upload/客户公司信息模板.docx` })"
            >
              下载模板
            </div>
          </span>
          <span class="mr10">
            <div class="radish-btn radish-btn-primary radish-btn-small" @click="parseTemplateText">解析</div>
          </span>
          <span class="ft-gray ft-small"
            >1、下载模板 2、按照模板填写内容 3、将内容复制并粘贴至下面的文本框内 4、点击解析</span
          >
        </p>
        <el-input
          v-model="templateText"
          type="textarea"
          size="mini"
          class="content-padding"
          placeholder="粘贴按照模板格式写好的文字内容实现一键解析"
          :autosize="{ minRows: 2, maxRows: 6 }"
        />
      </div>
      <div class="content-row">
        <span class="title">一句话介绍：</span>
        <el-input v-model="company.一句话简介" type="textarea" autosize size="mini" placeholder="一句话简介"></el-input>
      </div>
      <div class="content-row">
        <span class="title">公司详细介绍：</span>
        <el-input v-model="company.公司介绍" type="textarea" autosize size="mini" placeholder="公司介绍"></el-input>
      </div>
      <div class="content-row"><tagInputInEdit v-model="company['公司亮点']" label="公司亮点"></tagInputInEdit></div>
      <div class="content-row"><tagInputInEdit v-model="company['公司劣势']" label="公司劣势"></tagInputInEdit></div>
      <div class="company-type">
        <tagInputInEdit
          v-model="company['业务特点/风格/资源来源']"
          label="业务特点/风格/资源来源"
          :translate="translate"
        ></tagInputInEdit>
      </div>
    </div>
    <div class="createCompany-type pd8">
      <p class="company-type-title">3.客户信息</p>
      <div class="flex pdtb8">
        <div class="flex flex-2 pdr8">
          <span class="label">是否签约：</span>
          <el-select v-model="company.签约" placeholder="请选择" size="mini">
            <el-option v-for="item in sign" :key="item" :value="item"></el-option>
          </el-select>
          <!-- <el-checkbox v-model="issign" class="content" @change="changeSign"></el-checkbox> -->
        </div>
        <div class="flex flex-3 pdr8">
          <span class="label">签约时间：</span>
          <el-date-picker v-model="company.签约时间" class="edit-input" type="date" size="mini"></el-date-picker>
        </div>
        <div class="flex flex-2 pdr8">
          <span class="label">客户开发：</span>
          <el-select v-model="company.客户开发" class="content" size="mini" filterable>
            <el-option v-for="item in users" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <footer>
      <span class="radish-btn radish-btn-small cancel-btn" @click="close">取消</span>
      <span class="radish-btn radish-btn-primary radish-btn-small confirm-btn" @click="save">保存</span>
    </footer>
  </div>
</template>
<script>
import * as commonvariant from '../statistics/variant/commonvariant.js'
import AddTagInput from './baseComponent/AddTagInput'
import tagInputInEdit from './baseComponent/tagInputInEdit'
import { download, parseTemplateText } from '../../project/src/constant/utils.js'

export default {
  components: { AddTagInput, tagInputInEdit },
  data() {
    return {
      isShow: false,
      zIndex: 100,
      dialogBindRadish: true,
      sign: ['已签约', '项目拟客户', '跟进中'],
      industry: app.industries || [],
      inputError: {
        公司名称: false,
        简称: false,
        行业: false,
      },
      companyAliasArr: [],
      company: {},
      hasCreateCompany: null,
      templateText: '',
      translate: commonvariant.风格对应,
      users: [],
      issign: false,
      companyNameOptions: [],
      host: 'https://www.aconsulting.top',
    }
  },
  computed: {
    download() {
      return download
    },
    // host() {
    //   return window.host
    // },
  },
  watch: {
    $route(to, from) {
      this.close()
    },
  },
  async mounted() {
    if (!app.accounts) await app.getUsers()
    const notshow = ['admin', 'test', 'wpgao', 'cctang', 'test1', 'yezuochang', 'hktang']
    this.users = app.accounts.filter(val => !notshow.includes(val))
  },
  methods: {
    open() {
      this.company = {}
      this.init()
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    async newCheckCompanyName(query) {
      const res = await app.service('company').newCheckCompanyName(query)
      if (res.status === 'success') this.companyNameOptions = res.data
      else this.$message.error(res.msg)
    },
    checkRequiredField(field) {
      const value = this.company[field]
      if (field === '公司名称') {
        const choose = this.companyNameOptions.find(val => val.公司名称 === value)
        if (choose && choose.公司介绍) this.company.公司介绍 = choose.公司介绍
        this.checkCompanyName(field)
      } else if (field === '简称') this.checkCompanyName(field)
      else this.inputError[field] = !this.company[field]
    },
    async checkCompanyName(field) {
      this.hasCreateCompany = null
      const name = this.company[field]
      if (!name) return (this.inputError[field] = true)
      const res = await app.service('company').checkHasCompany(name)
      if (res.status === 'success') {
        this.inputError[field] = !!res.companyId
        this.hasCreateCompany = { _id: res.companyId, name: res.companyName }
      } else this.$message.error(res.msg)
    },
    async confirmAlias(name) {
      if (!name) return
      const res = await app.service('company').checkCompanyAlias(name)
      if (res.status == 201) {
        this.companyAliasArr.push({ name: name, type: 'success' })
      } else if (res.status == 200) {
        this.companyAliasArr.push({ name: name, type: 'danger' })
      } else {
        this.$message.error(res.msg)
      }
    },
    init() {
      const obj = {}
      const objFields = ['公司亮点', '公司劣势', '业务特点/风格/资源来源']
      objFields.forEach(field => {
        obj[field] = JSON.parse(JSON.stringify(commonvariant[field === '业务特点/风格/资源来源' ? '风格' : field]))
      })
      this.inputError = { 公司名称: false, 简称: false, 行业: false }
      this.companyAliasArr = []
      this.templateText = ''
      this.company = obj
    },
    parseTemplateText() {
      const json = parseTemplateText(this.templateText)
      const i18n = {
        用人偏好: '用人偏好备注',
        目标公司: '目标公司备注',
        目标人选: '目标人选备注',
        一句话介绍: '一句话简介',
        公司薪酬概况: '薪酬/职级/奖金机制',
        // 'Q&A': '其他',
      }
      const company = Object.assign({}, this.company)
      for (const key in json) {
        if (json.hasOwnProperty(key)) {
          if (['业务特点/风格/资源来源', '公司亮点', '公司劣势'].includes(key)) {
            if (!company[key]) company[key] = {}
            company[key].content = json[key]
          } else {
            company[i18n[key] || key] = json[key]
          }
        }
      }
      this.company = Object.assign({}, company)
    },
    changeSign(val) {
      this.company.签约 = val ? '已签约' : '未签约'
    },
    deleteAlias(val) {
      this.companyAliasArr.splice(this.companyAliasArr.indexOf(val), 1)
    },
    openCompany(company) {
      window.open(`${window.origin}/#/company/${company._id}`)
    },
    async save() {
      if (this.loading) return this.$message.info('保存中，请稍等一下')
      this.loading = true
      const { inputError, company, companyAliasArr } = this
      let couldSave = true
      for (const field in inputError) {
        if (!company[field]) {
          this.inputError[field] = true
          couldSave = false
          this.$message.error(`${field}未填写`)
          break
        } else if (inputError[field]) {
          couldSave = false
          this.$message.error(`${field}未通过校验，请检查并重新输入`)
          break
        }
      }
      if (!couldSave) return (this.loading = false)
      company.时间 = Date.parse(new Date())
      const res = await app.service('company').quickCreateCompany({
        company: company,
        companyAlias: companyAliasArr.map(v => ({ 别名: v.name })),
      })
      this.loading = false
      if (res.status === 200 || res.status === 'success') {
        this.isShow = false
        this.openCompany(res.data)
      } else this.$message.error(res.msg)
    },
  },
}
</script>
<style>
.inputError .listbox .el-input .el-input__inner,
.inputError .el-input .el-input__inner {
  border-color: #f13000;
}
</style>
<style src="../statistics/css/createCompany.css" scoped></style>
